<script>
  export let label;
  export let activeTab;
  export let onClick;

  let css;

  $: {
    const baseCss = "bg-transparent f4 tab pv2 ph3 mr3 lato";
    css =
      baseCss +
      " " +
      (activeTab
        ? "bb bw1 b--black-40 black-70"
        : "bb bw1 b--transparent black-70 pointer");
  }
</script>

<button disabled={activeTab} on:click={onClick} class={css}>{label}</button>

<style>
</style>
